import React from 'react';
import { isNil } from 'lodash';
import Anchor from '../Anchor';
import { setDetailPageUrl } from '../../../lib/common';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

const OpenUserDetail = (props) => {
  const { text, userId } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) && isNil(userId)) {
    return <>-</>;
  }

  return (
    <Anchor
      text={text}
      isUnderLine
      color="primary"
      href={setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, userId)}
      target="_blank"
    />
  );
};

export default OpenUserDetail;
